import React from "react";
import { useParams } from "react-router-dom";
import CompanyEventsLanding from "./CompanyEventsLanding";
import CompanyEventsList from "./CompanyEventsList";

const CompanyEvents = props => {
  const { eventList } = useParams();
  const { orgId, orgName } = props;

  return eventList === "list" ? (
    <CompanyEventsList orgId={orgId} orgName={orgName} />
  ) : (
    <CompanyEventsLanding orgId={orgId} orgName={orgName} />
  );
};

export default CompanyEvents;
